"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteActivity = void 0;
var FavoriteActivity;
(function (FavoriteActivity) {
    FavoriteActivity["SPORT"] = "SPORT";
    FavoriteActivity["ART"] = "ART";
    FavoriteActivity["FOOD"] = "FOOD";
    FavoriteActivity["NIGHT_LIFE"] = "NIGHT_LIFE";
    FavoriteActivity["CULTURE"] = "CULTURE";
    FavoriteActivity["HISTORY"] = "HISTORY";
    FavoriteActivity["TRAVELS"] = "TRAVELS";
    FavoriteActivity["SHOPPING"] = "SHOPPING";
    FavoriteActivity["WELLNESS"] = "WELLNESS";
    FavoriteActivity["PETS"] = "PETS";
})(FavoriteActivity = exports.FavoriteActivity || (exports.FavoriteActivity = {}));
//# sourceMappingURL=FavoriteActivity.js.map